package pwgs.ui.scenes.trialsettingsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.div
import visage.ds.components.Button
import visage.ds.components.Card
import visage.ds.components.EButtonColor
import visage.ds.components.Text

class MTrialSettingsScene(props: TrialSettingsSceneProps) : AScene<TrialSettingsSceneProps, TrialSettingsSceneModel, TrialSettingsSceneState, TrialSettingsControllerFe>(props) {

    override fun createController() : TrialSettingsControllerFe {
        return TrialSettingsControllerFe(props, this)
    }

    override fun initState() : TrialSettingsSceneState {
        return TrialSettingsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MTrialSettingsScene.model
        val controller = this@MTrialSettingsScene.controller
        Card {
            isLoading = model.isLoading
            header("Trial season") {
                if (!model.isLoading && model.trialDays > 0) {
                    ResponsiveButton("trash", "Stop season", EButtonColor.Danger, controller::stopTrialSeason)
                }
            }
            body {
                if (!model.isLoading) {
                    div {
                        style.apply {
                            padding = "16px"
                        }

                        if (model.trialDays > 0) {
                            Text("Trial season is already running since ${model.trialSeasonStartedAt} with ${model.trialDays} days.")
                        } else {
                            Text("There is no active trial season")
                        }
                    }

                    div {
                        style.apply {
                            padding = "16px"
                        }

                        Button("Start new 7 day trial season") {
                            color = EButtonColor.Success
                            onClick = {
                                controller.startTrialSeason(7)
                            }
                        }
                    }
                }
            }
        }
    }
}

class TrialSettingsSceneState {

}

fun Components.TrialSettingsScene(props: TrialSettingsSceneProps) = this.registerComponent(MTrialSettingsScene(props), {})
